import { render, staticRenderFns } from "./slider-widget.vue?vue&type=template&id=ddcdb608&scoped=true&"
import script from "./slider-widget.vue?vue&type=script&lang=js&"
export * from "./slider-widget.vue?vue&type=script&lang=js&"
import style0 from "./slider-widget.vue?vue&type=style&index=0&id=ddcdb608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcdb608",
  null
  
)

export default component.exports